export { default } from './components/Search'
